import { Publisher, Subscriber, createPublisher } from 'common';
import { createSignal, Accessor, Setter, createEffect, createMemo } from 'solid-js';
import { createStore, SetStoreFunction, Store } from 'solid-js/store'
import { view as api, ViewDefinition, ViewState } from 'st-app/api';

class ControlState {
    isDirty: boolean = false;
}

export class ViewContext {
    viewId: Accessor<string>; setViewId: Setter<string>
    tabId: Accessor<string>; setTabId: Setter<string>
    primaryObjectGU: Accessor<string>; setPrimaryObjectGU: Setter<string>
    identity: Accessor<string>; setIdentity: Setter<string>
    
    definition: ViewDefinition | undefined = undefined
    private setDefinition: SetStoreFunction<ViewDefinition>

    events: any
    viewState: Accessor<ViewState>;

    onSave: Subscriber<ViewContext>;
    private doSave: Publisher<ViewContext>;

    private controlState: Store<Record<string, ControlState>>;
    private setControlState: SetStoreFunction<Record<string, ControlState>>;

    serverState: Store<Record<string, string>>;
    setServerState: SetStoreFunction<Record<string, string>>;

    constructor() {
        [this.definition, this.setDefinition] = createStore<ViewDefinition>(new ViewDefinition());
        [this.viewId, this.setViewId] = createSignal('');
        [this.tabId, this.setTabId] = createSignal('');
        [this.primaryObjectGU, this.setPrimaryObjectGU] = createSignal('');
        [this.identity, this.setIdentity] = createSignal('');
        [this.onSave, this.doSave] = createPublisher<ViewContext>();
        [this.controlState, this.setControlState] = createStore<Record<string, ControlState>>({});
        [this.serverState, this.setServerState] = createStore<Record<string, string>>({});

        this.viewState = createMemo(() => ({
            viewGU: this.viewId(),
            tabGU: this.tabId(),
            identity: this.identity(),
            dataElements: [],
            gridElements: [],
            serverState: this.serverState
        }));

        createEffect(async () => {
            if (!this.viewId()) return

            if (import.meta.env.DEV) {
                try {
                    const def = await api.LoadViewDefinition(this.viewId())
                    this.setDefinition(def)
                } catch (e) { console.error(e); }
            }
        })
    }

    getControlState(ctrlId: string) {
        if (!this.controlState[ctrlId]) {
            this.setControlState(ctrlId, new ControlState());
        }
        return this.controlState[ctrlId];
    }

    setDirtyState(ctrlId: string, isDirty: boolean) {
        this.getControlState(ctrlId);
        this.setControlState(ctrlId, 'isDirty', isDirty);
    }
}
